import {
  Mesh,
  RingGeometry,
  MeshNormalMaterial,
  DoubleSide,
  Vector3,
} from 'three';
import { SceneService } from './../scene.service';
import { RingModel } from './../../model';
import { Component, OnInit } from '@angular/core';
import { EntityComponent } from '../share/entity-component';
import { RendererService } from '../renderer.service';

@Component({
  selector: 'ng3-ring',
  templateUrl: './ring.component.html',
  styleUrls: ['./ring.component.css'],
})
export class RingComponent extends EntityComponent<RingModel> {
  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }
  createEntity(model: RingModel) {
    const result = new Mesh(
      new RingGeometry(
        model.innerRadius,
        model.outerRadius,
        model.thetaSegments,
        model.phiSegments,
      ),
      new MeshNormalMaterial({ side: DoubleSide, wireframe: true }),
    );
    result.name = 'ring';
    result.position.copy(model.center);
     // result.rotation.x = - Math.PI / 2;
    return result;
  }
  updateEntity(model: RingModel, entity: Mesh) {
    entity.position.copy(model.center);
    entity.geometry = new RingGeometry(
      model.innerRadius,
      model.outerRadius,
      model.thetaSegments,
      model.phiSegments,
    );
    return entity;
  }
  defaultModel() {
    return new RingModel(new Vector3(0, 0, 0), 29.9, 30);
  }
}
